module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/img/twitter_page5.18b5bb66.jpg";